import React, { useState } from 'react';
import AppLinks from '../components/display/AppLinks';
import Sidebar from '../components/Sidebar';

const FAQ_DATA = [
  {
    question: "Who can use ToyTrade?",
    answer: "ToyTrade is designed for everyone in Pakistan who wants to exchange or buy/sell toys. It's a great way to declutter your home or find fresh and exciting toys for your kids. We welcome parents, toy enthusiasts, and even teens (with adult supervision). Businesses and local toy stores are also welcome to post their products."
  },
  {
    question: "Is ToyTrade free to use?",
    answer: "Yes! Basic posting and browsing on the ToyTrade platform is completely free. Our mission is to facilitate the toy trading community in Pakistan. We are charging only large businesses"
  },
  {
    question: "How do I trade my toys with others?",
    answer: "Trading is simple: Post your toy on the app with a clear photo and description. If someone is interested, they will contact you. You can then discuss the terms of the trade—whether it's a direct exchange, a partial payment, or a full sale. All communication happens directly between users."
  },
  {
    question: "How do I send or receive items?",
    answer: "ToyTrade is a marketplace platform and does not handle logistics directly. Users usually arrange for in-person pickups in their city, or use local courier services like TCS, Leopards, or Bykea for delivery. We recommend choosing a safe, public place for in-person handovers."
  },
  {
    question: "Can I sell toys without trading?",
    answer: "Absolutely. While we encourage the eco-friendly spirit of trading, many users and small businesses use ToyTrade simply to sell new or pre-loved toys at great prices. You can specify whether you are open to exchange in your item listing."
  },
  {
    question: "Can I trust other users on the platform?",
    answer: "Trust is built through our community rating system. After every interaction, you can rate and review the person you dealt with. We highly recommend checking a user's profile and ratings before finalizing a trade. If you encounter any suspicious activity, please report the user immediately."
  },
  {
    question: "What cities are supported by ToyTrade?",
    answer: "ToyTrade is available across all major cities in Pakistan, including Karachi, Lahore, Islamabad, Rawalpindi, Faisalabad, Multan, and Peshawar and many other cities. You can filter items by your city to find local deals and avoid shipping costs."
  },
  {
    question: "How do I negotiate and lock a deal?",
    answer: "Once you start a chat with someone, any participant can add items to the shared trade window. This allows both parties to clearly see what is being offered. You can negotiate back and forth, adding or removing items until both are happy. Once the terms are set, you both click 'Accept' to lock the deal officially."
  },
  {
    question: "Can I include cash/money in a trade?",
    answer: "Yes! ToyTrade supports flexible deals. You can propose a trade involving only items, only money (a straight sale), or a combination of both (e.g., one toy plus Rs. 500 for a more expensive item). You can easily specify the cash amount within the chat's negotiation window."
  },
  {
    question: "What happens after both parties accept the deal?",
    answer: "After the deal is locked on the app, the actual trade happens offline. You and the other user can coordinate your preferred mode of exchange through the chat—whether it's meeting in person for a handover or using an online payment method combined with a courier service. ToyTrade facilitates the agreement, while the physical exchange is completed by the users."
  },
  {
    question: "How do I post my items to the website?",
    answer: "To ensure quality and security, item posting is currently handled through the ToyTrade mobile app. Simply download the app on your Android or iOS device, create an account, and click the 'Post' button to list your toy in seconds. It will then appear on both the app and the website!"
  }
];

function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="container-xxl py-4 text-start">
      {/* FAQ Banner Header */}
      <div className="faq-banner text-center mb-5">
        <h1 className="fw-bold mb-3">Frequently Asked Questions</h1>
        <p className="text-muted lead">Everything you need to know about ToyTrade Pakistan</p>
      </div>

      <div className="row">
        <div className="col-lg-8">
          <div className="faq-accordion">
            {FAQ_DATA.map((item, index) => (
              <div
                key={index}
                className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              >
                <div
                  className="faq-header"
                  onClick={() => toggleAccordion(index)}
                >
                  <h4 className="mb-0">{item.question}</h4>
                  <div className="faq-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                    </svg>
                  </div>
                </div>
                <div className="faq-content">
                  <div className="faq-content-inner">
                    <p className="m-4">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Reusable Sidebar Component */}
        <div className="col-lg-4 d-none d-lg-block">
          <Sidebar />
        </div>
      </div>

      <div className="footer-promo mt-5 text-center py-5 rounded-4 highlighted-bar" >
        <h4 className="fw-bold mb-3">Still have questions?</h4>
        <p className="mb-4">Download the ToyTrade app to connect with our community and start trading today!</p>
        <AppLinks className="justify-content-center" />
      </div>
    </div>
  );
}

export default Faq;
